export const errorLiterals = {
  email: {
    invalid: "Email is not correct",
  },
  phone: {
    invalid: "Phone is not correct",
  },
};
